/*!

=========================================================
* Argon Dashboard React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { Link } from "react-router-dom";
import moment from "moment";
// reactstrap components
import {
  Card,
  CardHeader,
  Table,
  Container,
  Row,
  Form,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
} from "reactstrap";
// core components
import Header from "../Headers/Header";
import Col from "reactstrap/lib/Col";
import getDashboardData from "../../services/dashboardservice";

class DashboardSummary extends React.Component {
  intervalId;
  state = {
    dashboardData: [],
    searchValue: "",
  };
  componentDidMount() {
    this.callDashboardData();
  }

  async callDashboardData() {
    const dashboardData = await getDashboardData();
    this.setState({ dashboardData });
    this.intervalId = setInterval(async () => {
      const dashboardData = await getDashboardData();
      this.setState({ dashboardData });
    }, 5000);
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  handleSearch = (text) => {
    this.setState({ searchValue: text });
  };

  //logic to calculate vehicle status
  vehicleStatus(row) {
    let status = "";
    const ont = parseInt(row.ont);
    const oft = parseInt(row.oft);
    const spd = parseInt(row.spd);
    if (oft !== 0 && spd === 0) {
      status = "Parked";
    } else if (ont !== 0 && spd === 0) {
      status = "Idle";
    } else if (ont !== 0 && spd !== 0) {
      status = "Moving";
    } else {
      status = "Nothing";
    }
    return status;
  }

  //logic to calculate vehicle status
  accDuration(row) {
    let ont_oft;
    if (parseInt(row.ont) !== 0) {
      ont_oft = parseInt(row.ont);
    } else {
      ont_oft = parseInt(row.oft);
    }
    return moment.unix(parseInt(ont_oft)).fromNow("ss");
  }

  //logic to calculate device status
  //if last communication time is less than 15 minutes to the current timestamp, then it is ON, otherwise it is OFF
  deviceStatus(row) {
    const incomeTimeStamp = moment.unix(parseInt(row.tsp));
    const currentTimeStamp15MinutesLess = moment(Date()).subtract(
      15,
      "minutes"
    );
    const deviceStatus = incomeTimeStamp.isAfter(currentTimeStamp15MinutesLess);
    return deviceStatus ? "ON" : "OFF";
  }

  render() {
    const { dashboardData: dashboardDataState, searchValue } = this.state;
    const dashboardData = dashboardDataState.filter((value) =>
      value.vid.includes(searchValue)
    );
    return (
      <>
        <Header dashboardData={this.state.dashboardData} />
        {/* Page content */}
        <Container className="mt--3" fluid>
          {/* Table */}
          <Row>
            <div className="col">
              <Card className="shadow">
                <CardHeader className="border-0">
                  <Row style={{ alignItems: "center" }}>
                    <Col>
                      <h3 className="mb-0">Device Detailed Summary</h3>
                    </Col>
                    <Col>
                      <Form className="navbar-search navbar-search form-inline mr-3 d-none d-md-flex ml-lg-auto">
                        <FormGroup className="mb-0">
                          <InputGroup className="input-group-alternative">
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>
                                <i className="fas fa-search" />
                              </InputGroupText>
                            </InputGroupAddon>
                            <Input
                              placeholder="Search"
                              type="text"
                              onChange={(e) =>
                                this.handleSearch(e.target.value)
                              }
                            />
                          </InputGroup>
                        </FormGroup>
                      </Form>
                    </Col>
                  </Row>
                </CardHeader>
                <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                    <tr>
                      <th scope="col">Device Name</th>
                      <th scope="col">Vehicle Type</th>
                      <th scope="col">Last Commn. Time</th>
                      <th scope="col">Speed (KPH</th>
                      <th scope="col">Trip (KM)</th>
                      <th scope="col">ACC Status</th>
                      <th scope="col">ACC Duration</th>
                      <th scope="col">Device Status</th>
                      <th scope="col">Vehicle Status</th>
                      <th scope="col">GMap</th>
                      <th scope="col">Track</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dashboardData.map((row, index) => (
                      <tr key={index}>
                        <td>{row.vid}</td>
                        <td
                          style={{ verticalAlign: "middle" }}
                          className="text-center"
                        >
                          {row.vtp}
                        </td>
                        <td className="text-center">
                          {moment
                            .unix(parseInt(row.tsp))
                            .format("YYYY-MM-DD h:mm a")}
                        </td>
                        <td
                          style={{ verticalAlign: "middle" }}
                          className="text-center"
                        >
                          {row.spd}
                        </td>
                        <td
                          style={{ verticalAlign: "middle" }}
                          className="text-center"
                        >
                          0
                        </td>
                        <td
                          style={{ verticalAlign: "middle" }}
                          className="text-center"
                        >
                          {row.ont !== 0 ? "ON" : "OFF"}
                        </td>
                        <td
                          style={{ verticalAlign: "middle" }}
                          className="text-center"
                        >
                          {this.accDuration(row)}
                        </td>
                        <td
                          style={{ verticalAlign: "middle" }}
                          className="text-center"
                        >
                          {this.deviceStatus(row)}
                        </td>
                        <td
                          style={{ verticalAlign: "middle" }}
                          className="text-center"
                        >
                          {this.vehicleStatus(row)}
                        </td>
                        <td
                          style={{ verticalAlign: "middle" }}
                          className="text-center"
                        >
                          <button
                            className="btn btn-link"
                            onClick={() => {
                              window.open(
                                `https://www.google.com/maps/search/?api=1&query=${row.lat},${row.lnt}`
                              );
                            }}
                          >
                            Link
                          </button>
                        </td>
                        <td
                          style={{ verticalAlign: "middle" }}
                          className="text-center"
                        >
                          <Link
                            to={{
                              pathname: "/trackvehicle",
                              data: {
                                vid: row.vid,
                                lat: row.lat,
                                lnt: row.lnt,
                                children: (
                                  <Header dashboardData={dashboardData} />
                                ),
                              },
                            }}
                            className="btn btn-link"
                          >
                            Track Vehicle
                          </Link>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Card>
            </div>
          </Row>
        </Container>
      </>
    );
  }
}

export default DashboardSummary;
